import { createContext, useContext } from "react";

const DEFAULT_CAMPAIGN_OPENING_ASSIST_CONTEXT = {
  highlightMessageId: null,
  emptyChatPlaceholder: null,
};

const CampaignOpeningAssistContext = createContext(null);

export const CampaignOpeningAssistProvider = ({
  highlightMessageId = null,
  emptyChatPlaceholder = null,
  children,
}) => (
  <CampaignOpeningAssistContext.Provider
    value={{ highlightMessageId, emptyChatPlaceholder }}
  >
    {children}
  </CampaignOpeningAssistContext.Provider>
);

//eslint-disable-next-line
export const useCampaignOpeningAssist = () =>
  useContext(CampaignOpeningAssistContext) ??
  DEFAULT_CAMPAIGN_OPENING_ASSIST_CONTEXT;

//eslint-disable-next-line
export const useCampaignOpeningAssistHighlightId = () =>
  useCampaignOpeningAssist().highlightMessageId;
